// extracted by mini-css-extract-plugin
export default {"mediaMediumUp":"(min-width: 48em)","mediaLargeUp":"(min-width: 64em)","container":"n8UHuaYWBWKg-L1oU1Qq1w==","asset":"Hhg4GCLv5A7ll9lVpUq4BA==","video":"hfaHg7GGZS0D+WpcY7nn+Q=="};